import React, { Children } from 'react';
import { connect } from 'react-redux';
import { actionCreators } from './action';

import CircularProgress from '@material-ui/core/CircularProgress';

function Spinner({spinner, children, displaySpinner}) {
  return spinner && displaySpinner ? <div style={{textAlign: 'center'}}><CircularProgress /></div>:children;
}

const mapStateToProps = state => {
    return {
      spinner: state.spinner,
      displaySpinner: state.tasks === "empty",
    };
  };

export default connect(
    mapStateToProps,
    actionCreators
)(Spinner)